export default class Customer {
  constructor(customerID, customerName, customerToken, defaultProviderID) {
    this.customerID = customerID;
    this.customerName = customerName;
    this.customerToken = customerToken;
    this.defaultProviderID = defaultProviderID;
  }
}
